/**
 * Puesta en marcha. Una entidad nueva nace «En implementación»: no recibe solicitudes (ni por el portal, ni por
 * correo, ni radicadas por un funcionario) hasta que su administrador cumple los requisitos y la pasa «En
 * operación». Desde ese momento se rechaza el cambio de configuración que rompa un requisito, y una revisión
 * diaria avisa a los administradores lo que caduca solo (festivos, certificado) o deja de responder (correo, motor).
 */
export const OperationStatus = { SETUP: 'SETUP', LIVE: 'LIVE' };
/** Nombre con que el seed crea la entidad: mientras se llame así, nadie le ha puesto el suyo. */
export const PLACEHOLDER_ENTITY_NAME = 'Entidad';
/** El nombre de la entidad, o `null` mientras no tenga uno propio: «Entidad» no se muestra como si fuera su nombre. */
export function realEntityName(name) {
    const n = name?.trim();
    return n && n !== PLACEHOLDER_ENTITY_NAME ? n : null;
}
/**
 * Pasos del asistente: lo que una entidad nueva tiene que configurar antes de operar. Van en orden y cada uno se abre
 * cuando el anterior cumple sus requisitos obligatorios (los usuarios se ubican en áreas; quién aprueba y firma y el triaje son usuarios).
 */
export const SETUP_STEPS = [
    { key: 'entidad', label: 'Entidad', path: '/configuracion/entidad' },
    { key: 'areas', label: 'Áreas', path: '/configuracion/organigrama' },
    { key: 'usuarios', label: 'Usuarios', path: '/configuracion/usuarios' },
    { key: 'funciones', label: 'Quién aprueba y firma', path: '/configuracion/organigrama' },
    { key: 'triaje', label: 'Personas de triaje', path: '/configuracion/canales' },
];
/**
 * Lo que una entidad nueva ya trae listo (tipos y flujos, calendario, correo, almacenamiento y motor; la firma del
 * expediente no es requisito: la plataforma provee el certificado y se configura en Expediente electrónico): la plataforma
 * lo provee, así que no son pasos del asistente ni detienen el paso a operación. Si uno falla, se avisa adentro de la
 * aplicación (el aviso del administrador, con el detalle en un panel) y en el estado de la configuración, con la
 * pantalla que lo resuelve.
 */
export const SETUP_PRESETS = [
    { key: 'almacenamiento', label: 'Almacenamiento de documentos', path: '/configuracion/almacenamiento' },
    { key: 'respaldo', label: 'Respaldo de documentos', path: '/configuracion/respaldo' },
    { key: 'procesos', label: 'Tipos de caso y flujos', path: '/configuracion/tipos' },
    { key: 'calendario', label: 'Calendario y plazos', path: '/configuracion/sla' },
    { key: 'correo', label: 'Correo de la entidad', path: '/configuracion/correo-saliente' },
    { key: 'servicios', label: 'Motor de decisión', path: '/configuracion/decision-engine' },
];
//# sourceMappingURL=setup.js.map